import { render, staticRenderFns } from "./AppTwodoto.vue?vue&type=template&id=4171a548&scoped=true&"
import script from "./AppTwodoto.vue?vue&type=script&lang=js&"
export * from "./AppTwodoto.vue?vue&type=script&lang=js&"
import style0 from "./AppTwodoto.vue?vue&type=style&index=0&id=4171a548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4171a548",
  null
  
)

export default component.exports